import { http } from '@/utils/http'
export const ENTITYBASE = window.$envUtils('VUE_APP_ENTITY_SERVICE')
export const getEntityList = (params) => {
  return http.get(`${ENTITYBASE}/entity/trainEntity`, { params })
}

export const addEntity = (params) => {
  return http.post(`${ENTITYBASE}/entity/trainEntity`, { params })
}

export const updateEntity = (params) => {
  return http.post(`${ENTITYBASE}/entity/trainEntitys`, { params })
}

export const deleteEntity = (params) => {
  return http.delete(`${ENTITYBASE}/entity/trainEntity`, { params })
}

export const getCategoryList = (params) => {
  return http.get(`${ENTITYBASE}/entity/categorys`, { params })
}

export const updateCategory = (params) => {
  return http.put(`${ENTITYBASE}/entity/category`, { params })
}

export const addCategory = (params) => {
  return http.post(`${ENTITYBASE}/entity/category`, { params })
}

export const deleteCategory = (params) => {
  return http.delete(`${ENTITYBASE}/entity/category`, { params })
}

export const addTag = (params) => {
  return http.post(`${ENTITYBASE}/entity/tag`, { params })
}

export const updateTag = (params) => {
  return http.put(`${ENTITYBASE}/entity/tag`, { params })
}

export const deleteTag = (data) => {
  return http.delete(`${ENTITYBASE}/entity/tag`, { data })
}

export const getTagList = (params) => {
  return http.get(`${ENTITYBASE}/entity/tags`, { params })
}

export const getCorpusList = (params) => {
  return http.get(`${ENTITYBASE}/entity/corpuss`, { params })
}

export const addCorpus = (data) => {
  return http.post(`${ENTITYBASE}/entity/corpus`, { data })
}

export const updateCorpus = (data) => {
  return http.put(`${ENTITYBASE}/entity/corpus`, { data })
}

export const deleteCorpus = (params) => {
  return http.delete(`${ENTITYBASE}/entity/corpus`, { params })
}

export const train = (params) => {
  return http.post(`${ENTITYBASE}/entity/train`, { params })
}

export const testCorpus = (params) => {
  return http.post(`${ENTITYBASE}/entity/test`, { params })
}

export const deleteCorpuss = (data) => {
  return http.delete(`${ENTITYBASE}/entity/corpuss`, { data })
}

export const getTagByName = (params) => {
  return http.get(`${ENTITYBASE}/entity/tag`, { params })
}
